export const DEFAULT_COLUMN_WIDTH = 150;
export const MIN_COLUMN_WIDTH = 60;
export const MAX_COLUMN_WIDTH = 800;
export const COLUMN_RESIZE_STEP = 10;
export const COLUMN_RESIZE_LARGE_STEP = 50;

export const clampColumnWidth = (width: number) =>
  Math.min(MAX_COLUMN_WIDTH, Math.max(MIN_COLUMN_WIDTH, width));
